import React from 'react';
import { Star } from 'lucide-react';

export default function CelebrationBanner({ stats }) {
  if (!stats) return null;

  return (
    <div className="relative bg-gradient-to-r from-rose-500 via-orange-500 to-amber-500 rounded-2xl p-5 text-white overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute -top-12 -right-12 w-24 h-24 bg-white bg-opacity-10 rounded-full animate-pulse"></div>
      <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-white bg-opacity-5 rounded-full"></div>
      
      <div className="relative z-10">
        {/* Title */}
        <div className="text-center mb-4">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Star className="w-6 h-6 animate-pulse" />
            <h2 className="text-2xl font-bold">Amazing Progress!</h2>
          </div>
          <p className="text-lg opacity-95">You're absolutely crushing it!</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <div className="text-3xl font-bold mb-1">{stats.booksRead || 0}</div>
            <div className="text-sm opacity-90">Books Read</div>
          </div>
          
          <div className="text-center">
            <div className="text-3xl font-bold mb-1">{stats.currentStreak || 0}</div>
            <div className="text-sm opacity-90">Day Streak</div>
          </div>
          
          <div className="text-center">
            <div className="text-3xl font-bold mb-1">
              ${(stats.totalEarned || 0).toFixed(2)}
            </div>
            <div className="text-sm opacity-90">Earned</div>
          </div>
        </div>

        {/* Additional Encouragement */}
        {stats.currentStreak >= 7 && (
          <div className="mt-4 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white bg-opacity-20 rounded-full text-sm font-medium">
              <Star className="w-4 h-4" />
              <span>You're on fire! Keep it up!</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}